<div [ngClass]="styles.componentContainer" class="theme-primary-bg component-container">
	<h2>{{'Event_VodPreview_Header' | translate}}</h2>
	<div [ngClass]="styles.previewContainer">
		<div [ngClass]="styles.playerContainer">
			<div [ngStyle]="{
				'height': (this.height * 0.66) + 'px',
				'width': (this.width * 0.66) + 'px'
			}">
				<vb-video-player *ngIf="!showThumbnailOnly" [disableLogHeartbeat]="true" [disableUserPreferenceStore]="true" [disableControls]="true" [forceEndTimeInSec]="15" [playbacks]="webcast.playbacks" [playerConfig]="playerConfig" [videoId]="webcast.id" [videoTitle]="webcast.vodInfo.title" [thumbnailUri]="webcast.vodInfo.thumbnailUri" [sourceType]="webcast.vodInfo.sourceType" (onPlay)="onPlayerPlay()" (onPlaybackEnded)="onPlayerPlaybackEnded()">
				</vb-video-player>
				<vb-ui-thumbnail-sheet-preview *ngIf="showThumbnailOnly" [thumbnailUri]="webcast.vodInfo.thumbnailUri" [height]="this.height * 0.66" [width]="this.width * 0.66">
				</vb-ui-thumbnail-sheet-preview>
			</div>
			<div *ngIf="showLabel" [ngClass]="styles.playerLabel" [ngStyle]="{
					'bottom': (this.height * 0.25) + 'px',
					'left': (this.width * 0.33 - (this.playerLabelWidth / 2)) + 'px'
				}">
				<span *ngIf="!showThumbnailOnly" #playerLabel>{{ 'Event_Webcast_Vod_Preview_Label' | translate}}</span>
			</div>
		</div>
		<div [ngClass]="styles.metadataContainer">
			<span [ngClass]="styles.metadataTitle">
				<strong>{{'Title' | translate}}: </strong>
				{{webcast.vodInfo.title}}
			</span>
			<span>
				<strong>{{'Duration' | translate}}: </strong>
				{{webcast.vodInfo.durationMs | vbTimespan:true:true}}
			</span>
			<span>
				<strong>{{'OwnedBy' | translate}}: </strong>
				{{webcast.vodInfo.ownerFirstName}} {{webcast.vodInfo.ownerLastName}}
			</span>
			<span>
				<strong>{{'Uploaded' | translate}}: </strong>
				{{webcast.vodInfo.whenUploaded | vbFormatDate:'L'}}
			</span>
		</div>
	</div>
</div>
